"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.XL = exports.LG = exports.MD = exports.SM = exports.XS = void 0;
var XS = 'xs';
exports.XS = XS;
var SM = 'sm';
exports.SM = SM;
var MD = 'md';
exports.MD = MD;
var LG = 'lg';
exports.LG = LG;
var XL = 'xl';
exports.XL = XL;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/constants/layout/ScreenSizes.js
// module id = 435
// module chunks = 209 210 211 212